"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Vehicles";

export default {
  getVehiclesTreeData() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetVehiclesTreeData`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  getVehiclesTreeDataWithCamera() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetVehiclesTreeDataWithCamera`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
